// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class EnhancedChatMessageData {
    hasError?: boolean;
    isLoading?: boolean;
    message?: string;
}
